import {useState, useEffect} from 'react';
import { useSelector, useDispatch } from 'react-redux';

import {Grid, Box,Typography} from '@mui/material';
import FieldView from 'core/components/layout/FieldView';
import {setStitchingtaskSorting} from 'store/slice/ManufSlice';

export default function StitchingtaskListTableHeader(){
  const dispatch = useDispatch();
  const {sorting} = useSelector((state) => state.manufslice.stitchingtaskDashboard);
  const {UpdateStatusModalOpen} = useSelector((state) => state.manufslice.taskinstanceDashboard);
  const {mobileView} = useSelector((state) => state.menu);

  
  const handleColumnClick = (column) => {
  const currentSorting = sorting.column === column ? !sorting.asc : true;
    dispatch(setStitchingtaskSorting({ column, asc: currentSorting }));     
  }
    return (
      
      <Grid container direction="row" sx={{ justifyContent: "flex-start", alignItems: "center", width: '100%', padding: 1, backgroundColor: 'primary.lighter' }}>
        {UpdateStatusModalOpen || mobileView?<>
          <Grid item lg={4} xs={6} ><Typography variant="h5" sx={{cursor:'pointer'}} onClick={()=>handleColumnClick('workername')}> Worker </Typography></Grid>
          <Grid item lg={2} xs={2} ><Typography variant="h5" sx={{cursor:'pointer'}} onClick={()=>handleColumnClick('assignedqty')}>Assigned</Typography></Grid>
          <Grid item lg={2} xs={2} ><Typography variant="h5" sx={{cursor:'pointer'}} onClick={()=>handleColumnClick('assignedqty')}>Earning</Typography></Grid>
          <Grid item lg={2} xs={2} ><Typography variant="h5" sx={{cursor:'pointer'}} onClick={()=>handleColumnClick('receivedqty')}>Received</Typography></Grid>
          </>:
          <>
          <Grid item lg={1} xs={2} ><Typography variant="h5" sx={{cursor:'pointer'}} onClick={()=>handleColumnClick('orderid')}>Order #</Typography></Grid>
          <Grid item lg={1} xs={2} ><Typography variant="h5" sx={{cursor:'pointer'}} onClick={()=>handleColumnClick('orderid')}>S-Order #</Typography></Grid>
          <Grid item lg={2} xs={2} ><Typography variant="h5" sx={{cursor:'pointer'}} onClick={()=>handleColumnClick('productname')}>Product</Typography></Grid>
          <Grid item lg={2} xs={6} ><Typography variant="h5" sx={{cursor:'pointer'}} onClick={()=>handleColumnClick('workername')}> Worker </Typography></Grid>
          <Grid item lg={1} xs={2} ><Typography variant="h5" sx={{cursor:'pointer'}} onClick={()=>handleColumnClick('assignedqty')}>Assigned</Typography></Grid>
          
          <Grid item lg={1} xs={2} ><Typography variant="h5" sx={{cursor:'pointer'}} onClick={()=>handleColumnClick('receivedqty')}>Received</Typography></Grid>
          <Grid item lg={1} xs={2} ><Typography variant="h5" sx={{cursor:'pointer'}} onClick={()=>handleColumnClick('assignedqty')}>Rate</Typography></Grid>
          <Grid item lg={1} xs={2} ><Typography variant="h5" sx={{cursor:'pointer'}} onClick={()=>handleColumnClick('assignedqty')}>Earning</Typography></Grid>
          <Grid item lg={1} xs={2} ><Typography variant="h5" sx={{cursor:'pointer'}} onClick={()=>handleColumnClick('taskstatusname')}>Status</Typography></Grid>
          </>}
      </Grid>
      
    )
}